import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import { Seo } from "../components/Seo";
import { PublicLayout, OpenGeneratorButton } from "../components/PublicLayout";
import site from "../content/site.json";

const F = site.faq;

export default function FAQ() {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: F.items.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <PublicLayout>
      <Seo title={F.title} description={F.description} path="/faq" jsonLd={faqJsonLd} />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 pt-14">
        <span className="inline-flex items-center gap-2 rounded-full border border-[#22D3EE]/30 bg-[#22D3EE]/10 px-3 py-1 text-xs font-semibold text-[#8BE8F5]">
          <HelpCircle className="w-3.5 h-3.5" /> Questions &amp; Answers
        </span>
        <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-50">
          {F.h1}
        </h1>
        <p className="mt-4 text-slate-300">{F.intro} Ready to try it?</p>
        <div className="mt-6">
          <OpenGeneratorButton testId="faq-top-open-generator" />
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 space-y-4">
        {F.items.map((f, i) => (
          <article key={i} data-testid={`faq-item-${i}`} className="rounded-2xl border border-[#1E2C48] bg-[#0D1424] p-6">
            <h2 className="font-heading text-lg sm:text-xl font-semibold text-slate-50">{f.q}</h2>
            <p className="mt-2.5 text-sm sm:text-base text-slate-300 leading-relaxed">
              {f.a}
              {f.link && (
                <>
                  {" "}
                  <Link to="/generator" className="text-[#22D3EE] underline">Open the generator</Link>.
                </>
              )}
            </p>
          </article>
        ))}
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 pb-16">
        <div className="rounded-3xl border border-[#1E2C48] bg-gradient-to-br from-[#0D1424] to-[#121B30] p-8 text-center">
          <h2 className="font-heading text-2xl font-bold text-slate-50">Still curious? Try it yourself</h2>
          <p className="mt-3 text-slate-400">Open the generator and create a song prompt in minutes.</p>
          <div className="mt-6 flex justify-center">
            <OpenGeneratorButton testId="faq-bottom-open-generator" label="Open Song Generator" className="h-12 px-7 text-base" />
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
